"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GroupTitleExample_1 = require("./GroupTitleExample");
exports.default = GroupTitleExample_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/components/GroupTitleExample/index.js
// module id = 1248
// module chunks = 8